<template>
  <div>
    <iModal title="短信验证" @on-cancel="cancel" v-model="shortMesage">
      <Form
        ref="formReset3"
        :model="formReset3"
        :rules="ruleReset3"
        inline
        :label-width="120"
      >
        <FormItem label="手机号码：" prop="phone">
          <Input
            type="text"
            style="width: 300px"
            v-model="formReset3.phone"
            disabled
            placeholder="请输入手机号码"
          />
        </FormItem>
        <FormItem label="验证码：" prop="captcha">
          <Input
            type="text"
            style="width: 180px; margin-right: 20px"
            v-model="formReset3.captcha"
            class="yzm"
            placeholder="请填写验证码"
          />
          <Button
            v-if="showCode"
            @click="getCaptcha('formReset3')"
            style="width: 100px"
            >获取验证码</Button
          >
          <Button v-else disabled style="width: 100px; padding: 0"
            >{{ count }}s后重新获取</Button
          >
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" class="s-btn-red" @click="cancel">取消</Button>
        <Button type="primary" class="s-btn-red" @click="reset('formReset3')"
          >确认</Button
        >
      </div>
    </iModal>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from "vuex";
export default {
  // 空白内容
  name: "shortMessage",
  props: {
    resetShow3: {
      type: Boolean,
      default: false,
    },
    indexs: {
      type: Number,
      default: 1,
    },
    phoneType: Number,
  },
  data() {
    return {
      formReset3: {
        phone: "",
        captcha: "",
      },
      ruleReset3: {
        phone: [{ required: true, message: "请输入手机号码", trigger: "blur" }],
        captcha: [{ required: true, message: "请输入验证码", trigger: "blur" }],
      },
      count: 0,
      showCode: true,
      timer: null,
      shortMesage: this.resetShow3,
      userInfos: {},
    };
  },
  watch: {
    resetShow3(newVal) {
      this.shortMesage = newVal;
      console.log(newVal);
      if (newVal) {
        this.userInfo();
      }
    },
  },
  components: {},
  mounted() {},
  methods: {
    ...mapMutations({
      setRole: "setRole",
      setUser: "setUser",
      setToken: "setToken",
      setTokenTime: "setTokenTime",
      setLogin: "setLogin",
      setCompany: "loginModule/setCompany",
      setExhibition: "loginModule/setExhibition",
      setJoinInfo: "loginModule/setJoinInfo",
    }),
    ...mapActions({
      sendLoginSms: "loginModule/sendLoginSms",
      validLoginCode: "loginModule/validLoginCode",
      getUser: "loginModule/getUser",
    }),
    async userInfo() {
      let user = await this.getUser();
      console.log("userInfo", user);
      this.userInfos = user;
      this.formReset3.phone = user.phoneNumber;
    },
    cancel() {
      this.$emit("update:resetShow3", !this.resetShow3);
      this.shortMesage = false;
    },
    async downTime(name) {
      let valid = null;
      if (this.validType === 0) {
        // 绑定新手机
        valid = await this.bindPhoneToken({
          UserId: this.adminInfo.id,
          NewPhoneNumber: this.formInline2.mobile,
        });
      }
      if (this.validType === 1) {
        // 验证原手机
        valid = await this.changePhoneOldToken({
          UserId: this.adminInfo.id,
          OldPhoneNumber: this.formInline.mobile,
        });
      }
      if (this.validType === 2) {
        // 绑定新手机
        valid = await this.changePhoneToken({
          UserId: this.adminInfo.id,
          OldPhoneNumber: this.phone,
          NewPhoneNumber: this.formInline2.mobile,
          token: this.firstToken,
        });
      }
      const TIME_COUNT = 60;
      if (!this.timer) {
        this.count = TIME_COUNT;
        this.showCode = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--;
          } else {
            this.showCode = true;
            clearInterval(this.timer);
            this.timer = null;
          }
        }, 1000);
      }
    },
    async getCaptcha(formName) {
      // this.resetShow3 = false;
      let datas = {
        phone: this.formReset3.phone,
        userId: this.userInfos.id,
      };
      let code = await this.sendLoginSms(datas);
      console.log("code", code);
      this.downTime();
    },
    // this.$Message.success("登录成功");
    reset(formName) {
      console.log("submit!");
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          // 验证码获取逻辑
          //...
          that.Submit();
        }
      });
    },
    async Submit() {
      let datas = {
        phone: this.formReset3.phone,
        userId: this.userInfos.id,
        code: this.formReset3.captcha,
      };
      let code = await this.validLoginCode(datas);
      console.log("code", code);

      if (code.result) {
        this.$Message.success("登录成功");
        console.log("code", code.data);
        if (this.indexs == 2) {
          this.$router.push("/mobile-backend/ex-list");
        } else {
          this.$router.push("/host/project");
        }
      } else {
        this.$Message.error(code.msg);
      }
    },
  },
};
</script>

<style scoped lang="scss">
@media screen and (max-width: 868px) {
  .s-btn-red {
    background: #0782ff !important;
    border: 1px solid #0782ff !important;
  }
  ::v-deep .ivu-modal {
    width: 330px !important;
    margin: 30% auto;
    .ivu-form-item {
      width: 100%;
      display: flex;
      .ivu-form-item-label {
        width: 96px !important;
        padding-right: 0;
      }
      .ivu-form-item-content {
        flex: 1;
        margin-left: 0 !important;
        width: 200px !important;
        // display: flex;
        .ivu-input-wrapper {
          width: 100% !important;
        }
        .yzm {
          margin-right: 0 !important;
          width: 116px !important;
          display: inline-block !important;
        }
        .yzm .ivu-input {
          width: 110px !important;
          display: inline-block !important;
        }
        .ivu-btn {
          padding: 0 !important;
          text-align: center !important;
          display: inline-block !important;
          width: 84px !important;
        }
      }
    }
  }
}
</style>